import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "wrapper"
};
const _hoisted_2 = {
  class: "wrapper-collapse"
};
const _hoisted_3 = {
  class: "wrapper-collapse-action"
};
const _hoisted_4 = {
  key: 0,
  class: "wrapper-container"
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  key: 2
};
const _hoisted_9 = {
  key: 0,
  class: "state no"
};
const _hoisted_10 = {
  key: 1,
  class: "state yes"
};
const _hoisted_11 = {
  key: 2,
  class: "state ing"
};
const _hoisted_12 = {
  class: "wrapper-action"
};
import { onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from 'vue-router';
import ImageItem from '../components/ImageItem';
import ImageViewer from '../components/ImageViewer';
import MonitorUpload from '@/components/Upload';
import { ElMessage } from "element-plus";
import { USERINFO } from "@/store/mutation-types";
import apis from '@/api';
import download from "@/utils/download";
export default {
  __name: 'Detail',
  setup(__props) {
    const {
      exportAdvertPictureCompare,
      exportAdvertPictureComparePdf
    } = download();
    const uploadVisible = ref(false);
    const viewerVisible = ref(false);
    const submitLoading = ref(false);
    const exportLoading = ref(false);
    const exportPdfLoading = ref(false);
    const assetsLibVisible = ref(false);
    const itemsLoading = ref(false);
    const userInfo = ref({});
    const disabled = ref(false);
    const elLoading = ref(false);
    const router = useRouter();
    const route = useRoute();
    const data = reactive({
      taskId: null,
      taskName: null,
      userName: null,
      uploadFiles: [],
      /*assetFiles: [],*/
      tableData: [],
      pagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      file: {},
      otherFiles: [],
      pickResult: 0,
      activeNames: ['base', 'upload', 'assets', 'action', 'result'],
      /* 比对结果计算参数 */
      taskMainStatus: 0,
      resultStatus: 0,
      size: 0,
      likeSize: 0,
      ids: null,
      picAdminArea: ''
    });
    const assetsLibClose = () => {
      assetsLibVisible.value = false;
    };
    const handleSelectedAssets = () => {
      assetsLibVisible.value = true;
    };
    const handleUpload = () => {
      uploadVisible.value = true;
    };
    const getUserInfo = () => {
      userInfo.value = JSON.parse(window.localStorage.getItem(USERINFO));
      data.userName = userInfo.value.userName;
    };
    const handleSelectedChange = assets => {
      console.log('assets', assets);
      let assetFiles = [];
      assets.forEach(f => {
        const item = {
          assetId: f.id,
          assetName: f.assetsName,
          assetUrl: f.srcInnUrl
        };
        assetFiles.push(item);
      });
      data.assetFiles = data.assetFiles.concat(assetFiles);
    };
    const handleSizeChange = val => {
      data.pagination.pageSize = val;
      queryTaskItems();
    };
    const handleCurrentChange = val => {
      data.pagination.pageNo = val;
      queryTaskItems();
    };
    const handlerUploadSuccess = files => {
      uploadVisible.value = false;
      if (files && files.length > 0) {
        let uploadFiles = [];
        files.forEach(f => {
          const item = {
            imgId: f.id,
            imgName: f.fileName,
            imgUrl: f.innerUrl
          };
          uploadFiles.push(item);
        });
        data.uploadFiles = data.uploadFiles.concat(uploadFiles);
      } else {
        ElMessage.error('请先上传印刷品附件!');
      }
    };
    onMounted(() => {
      if (route.query && route.query.id) {
        data.taskId = route.query.id;
      }
      if (route.query && route.query.picAdminArea) {
        data.picAdminArea = route.query.picAdminArea;
        // console.info("compare detail picAdminArea value:",data.picAdminArea)
      }
      if (data.taskId) {
        disabled.value = false;
        queryTaskById();
        queryTaskItems();
        queryTaskResultInfo();
      } else {
        disabled.value = true;
        getUserInfo();
      }
    });
    const queryTaskItems = () => {
      const params = {
        id: data.taskId,
        ...data.pagination
      };
      itemsLoading.value = true;
      apis.queryAdvertPictureCompareItemList(params).then(res => {
        if (res.success) {
          var _res$data;
          const {
            records,
            size,
            total,
            current
          } = (_res$data = res.data) !== null && _res$data !== void 0 ? _res$data : res.data = {};
          data.tableData = records !== null && records !== void 0 ? records : [];
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
          records.forEach(f => {
            let assertObj = JSON.parse(f.simInfo);
            if (assertObj !== undefined && assertObj !== null && assertObj.length > 0) {
              f.assertAry = assertObj;
              f.historyUpTime = assertObj[0].upTime;
              f.historyOperator = assertObj[0].operator;
              console.info(assertObj);
            }
          });
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        itemsLoading.value = false;
      });
    };
    const queryTaskById = () => {
      elLoading.value = true;
      apis.queryAdvertPictureCompareById(data.taskId).then(res => {
        if (res.success) {
          data.taskName = res.data.taskName;
          data.userName = res.data.userName;
          /*data.assetFiles = res.data.assetFiles*/
          data.uploadFiles = res.data.uploadFiles;
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
      });
    };
    const queryTaskResultInfo = () => {
      elLoading.value = true;
      apis.queryAdvertPictureCompareResultInfoById(data.taskId).then(res => {
        if (res.success) {
          data.taskMainStatus = res.data.taskMainStatus;
          data.resultStatus = res.data.resultStatus;
          data.size = res.data.size;
          data.likeSize = res.data.likeSize;
          data.ids = res.data.ids;
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
      });
    };
    const handleSubmit = () => {
      if (!data.taskName) {
        ElMessage.error('请先填写任务名称!');
        return;
      }
      if (data.uploadFiles.length == 0) {
        ElMessage.error('请先上传监测图片');
        return;
      }
      /* if (data.assetFiles.length == 0) {
         ElMessage.error('请先选择素材库图片');
         return
       }*/
      const task = {
        taskName: data.taskName,
        uploadFiles: data.uploadFiles,
        /* assetFiles: data.assetFiles*/
        areaCode: data.picAdminArea
      };
      console.log('task', task);
      submitLoading.value = true;
      apis.saveAdvertPictureCompareTask(task).then(res => {
        if (res.success) {
          ElMessage.success('广告比对任务已提交，请耐心等待任务处理结果，谢谢！');
          router.push({
            name: 'picture-compare-list'
          });
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        submitLoading.value = false;
      });
    };
    const handleExport = () => {
      exportLoading.value = true;
      exportAdvertPictureCompare(data.taskId, data.taskName + ".docx").then(() => {
        exportLoading.value = false;
      }).finally(() => {
        exportLoading.value = false;
      });
    };
    const handleExportPdf = () => {
      exportPdfLoading.value = true;
      exportAdvertPictureComparePdf(data.taskId, data.taskName + ".pdf").then(() => {
        exportPdfLoading.value = false;
      }).finally(() => {
        exportPdfLoading.value = false;
      });
    };
    const handleView = row => {
      data.file = {};
      data.otherFiles = [];
      data.pickResult = row.result;
      data.file = {
        imgName: row.imgName,
        imgUrl: row.imgUrl,
        imgId: row.imgId
      };
      console.info(data.file);
      let assertObj = row.assertAry;
      if (assertObj !== undefined && assertObj !== null && assertObj.length > 0) {
        const otherFile = {
          imgName: assertObj[0].fileName,
          imgUrl: assertObj[0].innerUrl,
          imgId: assertObj[0].id
        };
        data.otherFiles.push(otherFile);
      }
      viewerVisible.value = true;
    };
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_collapse_item = _resolveComponent("el-collapse-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_collapse = _resolveComponent("el-collapse");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_collapse, {
        modelValue: data.activeNames,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.activeNames = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_collapse_item, {
          title: "基础信息",
          name: "base"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form, {
            inline: true
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "操作人",
              prop: "=userName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_row, null, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(data.userName), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "任务名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: data.taskName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.taskName = $event),
                placeholder: "请输入任务名称",
                disabled: !disabled.value
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_collapse_item, {
          name: "upload"
        }, {
          title: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_cache[6] || (_cache[6] = _createElementVNode("div", {
            class: "wrapper-collapse-title"
          }, "比对图片", -1)), _createElementVNode("div", _hoisted_3, [disabled.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            link: "",
            onClick: _withModifiers(handleUpload, ["stop"])
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("上传文件", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true)])])]),
          default: _withCtx(() => [_createElementVNode("div", null, [data.uploadFiles && data.uploadFiles.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.uploadFiles, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index
            }, [_createVNode(_unref(ImageItem), {
              name: item.imgName,
              url: item.imgUrl
            }, null, 8, ["name", "url"])]);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_empty, {
            description: "未上传",
            "image-size": "80"
          })]))])]),
          _: 1
        }), !disabled.value ? (_openBlock(), _createBlock(_component_el_collapse_item, {
          key: 0,
          title: "监测结果",
          name: "result"
        }, {
          default: _withCtx(() => [data.taskMainStatus == 1 ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0
          }, {
            default: _withCtx(() => [_cache[7] || (_cache[7] = _createElementVNode("div", {
              class: "ressty-title"
            }, " 比对结果 ", -1)), data.resultStatus == 0 ? (_openBlock(), _createElementBlock("p", _hoisted_6, " 本次上传监测图片" + _toDisplayString(data.size) + "张,与历史图片均不相似 ", 1)) : data.resultStatus == 1 ? (_openBlock(), _createElementBlock("p", _hoisted_7, " 本次上传监测图片" + _toDisplayString(data.size) + "张,其中" + _toDisplayString(data.likeSize) + "张与历史图片相似 ", 1)) : (_openBlock(), _createElementBlock("p", _hoisted_8, " 本次上传监测图片" + _toDisplayString(data.size) + "张,其中" + _toDisplayString(data.likeSize) + "张与历史图片相似,其中图片 [" + _toDisplayString(data.ids) + "] 比对出多张相似的历史图片，请反馈系统管理员核查 ", 1))]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_row, {
            key: 1
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createElementVNode("div", {
              class: "ressty-title"
            }, " 未比对或正在比对中，暂无比对结果报告 ", -1)]))]),
            _: 1
          })), _createElementVNode("div", null, [_createElementVNode("div", null, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: data.tableData,
            style: {
              "width": "100%"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              prop: "id",
              label: "编号"
            }), _createVNode(_component_el_table_column, {
              prop: "imgName",
              label: "监测图片"
            }), _createVNode(_component_el_table_column, {
              prop: "result",
              label: "比对结果"
            }, {
              default: _withCtx(scope => [scope.row.result == -1 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[9] || (_cache[9] = [_createElementVNode("div", {
                class: "state-tag close"
              }, null, -1), _createTextVNode(" 匹配失败 ", -1)]))])) : _createCommentVNode("", true), scope.row.result == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[10] || (_cache[10] = [_createElementVNode("div", {
                class: "state-tag success"
              }, null, -1), _createTextVNode(" 匹配成功 ", -1)]))])) : _createCommentVNode("", true), scope.row.result == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[11] || (_cache[11] = [_createElementVNode("div", {
                class: "state-tag loading"
              }, null, -1), _createTextVNode(" 无匹配数据 ", -1)]))])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              prop: "historyUpTime",
              label: "历史图片上传时间"
            }), _createVNode(_component_el_table_column, {
              prop: "historyOperator",
              label: "历史图片上传人"
            }), _createVNode(_component_el_table_column, {
              prop: "action",
              label: "操作"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_button, {
                link: "",
                type: "primary",
                size: "small",
                onClick: $event => handleView(scope.row)
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("查看", -1)]))]),
                _: 1
              }, 8, ["onClick"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])), [[_directive_loading, itemsLoading.value]])]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange,
            "page-sizes": [5, 10, 20, 30, 40],
            "page-size": data.pagination.pageSize,
            total: data.pagination.totalSize,
            currentPage: data.pagination.pageNo,
            "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => data.pagination.pageNo = $event),
            layout: "prev, pager, next, sizes, jumper"
          }, null, 8, ["page-size", "total", "currentPage"])])])]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_12, [disabled.value ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("开始比对", -1)]))]),
        _: 1
      })), [[_directive_loading, submitLoading.value]]) : _createCommentVNode("", true), !disabled.value ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        type: "primary",
        onClick: handleExport
      }, {
        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("导出WORD", -1)]))]),
        _: 1
      })), [[_directive_loading, exportLoading.value]]) : _createCommentVNode("", true), !disabled.value ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        type: "primary",
        onClick: handleExportPdf
      }, {
        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("导出PDF", -1)]))]),
        _: 1
      })), [[_directive_loading, exportPdfLoading.value]]) : _createCommentVNode("", true)])])), [[_directive_loading, elLoading.value]]), disabled.value ? (_openBlock(), _createBlock(_unref(MonitorUpload), {
        key: 0,
        visible: uploadVisible.value,
        "onUpdate:visible": _cache[3] || (_cache[3] = $event => uploadVisible.value = $event),
        multiple: true,
        onUploadSuccess: handlerUploadSuccess
      }, null, 8, ["visible"])) : _createCommentVNode("", true), _createVNode(_unref(ImageViewer), {
        visible: viewerVisible.value,
        "onUpdate:visible": _cache[4] || (_cache[4] = $event => viewerVisible.value = $event),
        file: data.file,
        "other-files": data.otherFiles,
        res: data.pickResult
      }, null, 8, ["visible", "file", "other-files", "res"])], 64);
    };
  }
};